/**
 * Lightweight analytics wrapper around Google Analytics 4 (gtag).
 * - Safe to call even if gtag isn't loaded yet (no-op).
 * - All custom events flow through trackEvent() for consistency.
 * - GDPR: events only land in GA when user has accepted analytics_storage via consent banner.
 */

const GA_ID = "G-86WNHZ15V2";

const safeGtag = (...args) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
};

/**
 * Update Google Consent Mode based on user choice from cookie banner.
 * @param {{ analytics: boolean, marketing: boolean }} prefs
 */
export function updateAnalyticsConsent({ analytics, marketing }) {
  safeGtag("consent", "update", {
    analytics_storage: analytics ? "granted" : "denied",
    ad_storage: marketing ? "granted" : "denied",
    ad_user_data: marketing ? "granted" : "denied",
    ad_personalization: marketing ? "granted" : "denied",
  });
}

/**
 * Track a custom event with optional params.
 * @param {string} eventName - GA4 event name (snake_case recommended)
 * @param {object} params - additional parameters (CTA name, page, etc.)
 */
export function trackEvent(eventName, params = {}) {
  safeGtag("event", eventName, params);
}

/**
 * Track a page view manually (useful for SPA navigation).
 * @param {string} path - URL path
 * @param {string} title - Page title
 */
export function trackPageView(path, title) {
  safeGtag("config", GA_ID, {
    page_path: path,
    page_title: title,
  });
}
